function s(t, a) {
  const n = t < 0 ? "-" : "", o = Math.abs(t).toString().padStart(a, "0");
  return n + o;
}
export {
  s as a
};
